import React from "react";
import { useDocumentMeta } from "../components/useDocumentMeta";
import Wizard from "../components/Wizard";
import CtaBand from "../components/CtaBand";

function Assessment() {
  useDocumentMeta(
    "Assessment",
    "Answer four questions about your platform journey and get a tailored recommendation — and how we've solved it before.",
  );

  return (
    <>
      <section className="page-hero">
        <div className="container">
          <p className="kicker">Assessment</p>
          <h1 className="page-title">Where's your biggest gain hiding?</h1>
          <p className="page-lead">
            Four quick questions. No email required to see the result. We'll
            point you to the problem we'd tackle first — and show you where we've
            solved it before.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container wizard-wrap">
          <Wizard />
        </div>
      </section>

      <CtaBand
        title="Want to talk it through?"
        text="Bring your result to a conversation and we'll map the first concrete steps with you."
        to="/contact"
        label="Talk to us"
      />
    </>
  );
}

export default Assessment;
